import locale_en from './locale-en.json';
import locale_de from './locale-de.json';
import { LanguageCode, languageMessage} from '../types/language';

//----Language Part ------
export const Messages: Array<languageMessage> = [{
    langcode: LanguageCode.DE,
    language: "Deutsch",
    locale: locale_de
  },
  {
    langcode: LanguageCode.EN,
    language: "English",
    locale: locale_en
  }];